import { Location } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ErrorWrapper } from 'src/app/lib/error/classes';

@Component({
  selector: 'app-error-dialog',
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.scss']
})
export class ErrorDialogComponent implements OnInit {

  message: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public error: ErrorWrapper,
    private _router: Router,
    private _location: Location,
    private _ref: MatDialogRef<ErrorDialogComponent>
  ) {
    this.message = error.description;
  }

  goBack = () => this._location.back();

  navigateToMainpage = () => {
    this._router.navigate(['/']);
    this._ref.close();
  }

  ngOnInit(): void {
  }

}
